import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { PRICING_TABLE_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import ProductShow from "../ProductShow";
import ProductNewForm from "../ProductNewForm";
import ProductOrderSettings from "../ProductOrderSettings";
import { SchemaPropTypes } from "utils/propTypes";

const ProductOrderHub = (props) => {
  const { name } = props;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const productsPath = `${name}.data.products`;
  const products = get(values, productsPath, []);
  const productOrderIntent = get(
    values,
    STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT
  );
  const activeUID = get(values, STATE_KEYS.EDITOR.PRICING_ACTIVE_PRODUCT);

  const pricePrimaries = get(values, STATE_KEYS.MANIFEST.PRICING_PRIMARIES);
  const activeProduct = products.find(({ uid }) => uid === activeUID);
  const showProduct = Boolean(activeProduct);

  let content = null;

  if (showProduct) {
    // Note: Important to use activeUID as key to re-mount block on product change
    content = <ProductShow key={activeUID} {...props} />;
  } else if (productOrderIntent === PRICING_TABLE_INTENT.PRODUCT_ADD) {
    content = (
      <ProductNewForm
        name={name}
        pricePrimaries={pricePrimaries}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
      />
    );
  } else {
    content = <ProductOrderSettings name={name} />;
  }

  return content;
};

ProductOrderHub.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.shape(SchemaPropTypes)
};

export default ProductOrderHub;
